<section class="carousel-wrapper" [ngStyle]="carouselWrapperStyle">
    <div id="schematicView">
        <ul class="carousel-inner" #carousel>
            <li *ngFor="let item of items;" class="carousel-item" style="position: relative;">
                <ng-container [ngTemplateOutlet]="item.tpl"></ng-container>
            </li>
        </ul>
    </div>  
</section>

<div id="navButtons" style="display: flex; flex-direction: row">
    <a class="button waves-effect" (click)="prev()" style="flex: 1;">
        <i class="material-icons button__icon">navigate_before</i>
        <span class="button__text">Previous</span>
    </a>
    <a class="button waves-effect" (click)="next()" style="flex: 1;">
        <i class="material-icons button__icon">navigate_next</i>
        <span class="button__text">Next</span>
    </a>
</div>